import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { createBankDepositTransaction } from '../../services'
import {
	CreateBankDepositTransactionRequest,
	CreateBankDepositTransactionResponse,
} from '../../../type'
import { BankMutationKeys } from '../../../keys'

type UseBaseMutationOptions<TData, TVariables> = Omit<
	UseMutationOptions<TData, Error, TVariables, unknown>,
	'mutationKey' | 'mutationFn'
>

interface UseMutationCreateBankDepositTransactionProps {
	payload: CreateBankDepositTransactionRequest
}

export default function useMutationCreateBankDepositTransaction(
	props?: UseBaseMutationOptions<
		CreateBankDepositTransactionResponse,
		UseMutationCreateBankDepositTransactionProps
	>,
) {
	return useMutation({
		mutationKey: [BankMutationKeys.CreateBankDepositTransaction],
		mutationFn: (params) => createBankDepositTransaction(params.payload),
		...props,
	})
}
